import React from 'react';
import {CalendarChangeRequestProvider} from '../context/CalendarChangeRequestProvider';
import ChangeRequestContainer from '../container/ChangeRequestContainer';

function ChangeRequestOverview(props) {
    return (
        <div className="sidebar-bottomcontent-container">
            <div className="sidebar-bottomcontent-container-row">
                <CalendarChangeRequestProvider onLogoutClick={props.onLogoutClick}
                    setSelectedNavItem={props.setSelectedNavItem} isLogout={props.isLogout}
                    setLogoutFalse={props.setLogoutFalse} clearSessionData={props.clearSessionData}>
                        <ChangeRequestContainer BusinessPartnerCode={props.BusinessPartnerCode} 
                                                UserId ={props.UserId}
                                                isNmbsUser={props.isNmbsUser}
                                                isEditAccess={props.isEditAccess}
                                                isLogout={props.isLogout}   
                                                onLogoutClick={props.onLogoutClick}
                                                clearSessionData={props.clearSessionData} 
                                                />
                </CalendarChangeRequestProvider> 
            </div>
        </div>
    );
}

export default ChangeRequestOverview;